import React, { ReactElement, FC } from 'react'
import { TrendBar } from './trendBar'

import './style.scss'
interface Props {
  party: string
  changePercentage: number
  color: string
  trendBarMaxValue: number
}
export const TrendRow: FC<Props> = ({
  party,
  changePercentage,
  color,
  trendBarMaxValue
}): ReactElement => {
  const gainedPercentage = +changePercentage === 0 ? 0 : changePercentage > 0
  return (
    <div>
      <div className='trend-row'>
        <div className='party'>{party}</div>
        <TrendBar
          maxValue={trendBarMaxValue}
          value={changePercentage}
          color={color}
        />
        <div
          className={
            gainedPercentage === 0
              ? 'change-percentage'
              : gainedPercentage
              ? 'win-color change-percentage'
              : 'lose-color change-percentage'
          }
        >
          {gainedPercentage === 0
            ? '=' + gainedPercentage + '%'
            : gainedPercentage
            ? '+' + changePercentage + '%'
            : changePercentage + '%'}
        </div>
      </div>
    </div>
  )
}
